/* ME.LOL — OG shirt-render upload.  Lives in the theme as assets/melol-og.js
   (kept OUT of theme.liquid to stay under Shopify's 256 KB template limit).
   On a product page it renders the current shirt (word on FinalFlatShirt, no finger —
   the clean share look) and uploads the PNG to the Worker /render, keyed by domain.
   The Worker stores it in R2 and serves it as the bare-domain og:image, so shares show
   the real shirt instead of a blank one. Self-contained; dedups per browser; skips
   domains the Worker already has. Nothing here touches the overlay/finger/capture code.

   ---------------------------------------------------------------------------------
   2026-09-05 — RENDER v3: "www." PILL ON THE HEM
   Civilians read "website" from .com and from "www." — not from .lol/.wtf. Our own
   orders prove the gap: someone paid $39.94 for queencatherine.darkwellcastle +
   queenmarie.darkwellcastle, which is not a TLD and never will be. So the SHARED
   image now carries a high-contrast pill reading www.<domain>, straddling the hem. A
   shared image has no surrounding context to lean on, so the prefix has to survive in
   the picture itself.

   Lime on its own field, not type floating on the garment: per
   featured-image-and-print-size-decisions-2026-08-08.md, the lime pill beat every other
   caption treatment on the 200px thumbnail test, because it sits on its own
   high-contrast field instead of competing with the shirt. Link previews ARE thumbnails,
   so the same finding applies.

   The CHEST PRINT IS UNTOUCHED. The pill is a share-image overlay only; nothing here
   feeds the DTF print path.

   CACHE TRAP THIS RELEASE DEFUSES: v1 skipped the upload whenever
   HEAD /shirt/<domain>.png returned 200. Every domain already in R2 would therefore
   keep its old, caption-less render forever and this change would reach nobody. So
   for RENDER_VER 3 the HEAD short-circuit is bypassed until this browser has uploaded
   a v3 render for that domain (tracked under a version-scoped localStorage key).
   Result: the fleet backfills itself from ordinary traffic — no /purge-all required,
   though purging just makes it happen faster.
   --------------------------------------------------------------------------------- */
(function(){
  if(window.__melolOgRender) return; window.__melolOgRender=1;
  if(location.pathname.indexOf('/products/')!==0) return;

  var RENDER_VER=3;                       // bump whenever the rendered artwork changes
  var SEEN_KEY='melol_og_up_v'+RENDER_VER;

  var WORKER='https://lively-fog-cef0.louddrums.workers.dev';
  var SHIRT='https://cdn.shopify.com/s/files/1/0714/1697/1451/files/FinalFlatShirt.png';
  var K={ size:1200, word:{ size:90, y:38.75, fitPct:32 }, tld:{ size:35, gap:-0.1 }, noFingerShift:13 };
  var VALID=/\.(lol|wtf|no|so|si|you|us|me|one|mom|dad|fyi|sh|to|news)$/;

  /* --- the www. pill ---------------------------------------------------------------
     A rounded pill CENTRED ON THE HEM, so it sits half on the garment and half off.

     WHY A PILL AND NOT A FULL-WIDTH BAND (changed 2026-09-05, John's call, confirmed by
     compositing on the real blank): a lime band running edge to edge across the shirt
     body reads as PART OF THE PRINT. That is self-defeating for a feature whose whole
     job is teaching people what is actually printed on the shirt — the chest says
     PAPA.LOL in white, and a second green box on the same garment muddies exactly the
     thing we are trying to make legible.

     Breaking the garment's outline is what fixes it. A pill that straddles the hem —
     part on black fabric, part on the pale background — plus a drop shadow and a white
     keyline reads unmistakably as a label laid ON TOP of a photo. Depth cues, not
     colour, are what separate "sticker" from "silkscreen".

     hem 92.3% is MEASURED off the production blank (FinalFlatShirt.png), not guessed:
     dark-pixel scan puts the garment bottom at y=554/600. That independently confirms
     Print Studio's calHem of 92.2% (print-studio-grid-and-size-scaling-2026-08-12.md),
     so the two tools now agree. At this setting the pill spans ~87.9%..96.7%.

     CROP NOTE: a square og:image centre-cropped to 1.91:1 keeps only y≈24%..76%, so on
     surfaces that do that (Facebook/X link cards — still an UNVERIFIED premise, see
     www-recognition-2026-09-05.md) this pill is cut off. Square-preserving surfaces —
     iMessage, WhatsApp, Signal, Google Messages/RCS, i.e. how this store's shares
     actually travel — show it fine. The "looks like part of the shirt" problem is
     certain; the crop problem is not. If the virgin-domain test ever shows link cards
     matter, drop `hem` to ~71.5 and the pill stays a pill, just higher up the torso. */
  var PILL={ hem:92.3, fs:56, padX:44, padY:25, bg:'#C6E600', fg:'#111111', maxWPct:88 };

  /* Special per-domain graphics — mirror of the theme's SPECIAL_GRAPHICS/SPECIAL_SIZE.
     When you add a special design in the theme, add the same entry here so shares match.
     (Ask me to centralize this into the Worker if the list gets long.) */
  var SPECIAL_GRAPHICS={ 'usa.lol':'https://cdn.shopify.com/s/files/1/0714/1697/1451/files/usa.lol.dumpsterfire.png?v=1780805700' };
  var SPECIAL_SIZE={ 'usa.lol':{ boxPct:16.6, y:22 } };

  function curDomain(){
    var w=document.getElementById('shirt-domain-word'), t=document.getElementById('shirt-domain-tld');
    if(w&&t){ var d=((w.textContent||'')+(t.textContent||'')).trim().toLowerCase().replace(/\?+$/,''); if(d.indexOf('.')>-1) return d; }
    try{ var p=new URLSearchParams(location.search).get('domain'); return (p||sessionStorage.getItem('melol_domain')||'').toLowerCase().trim(); }catch(e){ return ''; }
  }
  function seen(){ try{ return JSON.parse(localStorage.getItem(SEEN_KEY)||'[]'); }catch(e){ return []; } }
  function markSeen(d){ try{ var a=seen(); if(a.indexOf(d)<0){ a.push(d); if(a.length>500) a=a.slice(-500); localStorage.setItem(SEEN_KEY, JSON.stringify(a)); } }catch(e){} }

  function loadImg(src){ return new Promise(function(res){ var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){res(im);}; im.onerror=function(){res(null);}; im.src=src; }); }
  function render(domain, cb){
    var dot=domain.lastIndexOf('.');
    var wordTxt=(dot>-1?domain.slice(0,dot):domain).toUpperCase();
    var tldTxt=(dot>-1?domain.slice(dot):'').toUpperCase(); if(tldTxt==='.WTF'||tldTxt==='.SO'||tldTxt==='.TO') tldTxt+='?';
    var size=K.size;
    var special=SPECIAL_GRAPHICS[domain] || null;
    Promise.all([loadImg(SHIRT), special?loadImg(special):Promise.resolve(null)]).then(function(imgs){
      var shirt=imgs[0], gimg=imgs[1];
      var cv=document.createElement('canvas'); cv.width=size; cv.height=size;
      var ctx=cv.getContext('2d');
      ctx.fillStyle='#f0f0f0'; ctx.fillRect(0,0,size,size);
      if(shirt) ctx.drawImage(shirt,0,0,size,size);
      // special graphic (e.g. usa.lol dumpster fire), sized/positioned like the theme
      var hasGraphic=!!(gimg && gimg.naturalWidth);
      if(hasGraphic){
        var ss=SPECIAL_SIZE[domain]||{ boxPct:16.6, y:22 };
        var box=(ss.boxPct/100)*size, cx=size/2, boxTop=(ss.y/100)*size;
        var gr=gimg.naturalWidth/gimg.naturalHeight, dw, dh; if(gr>=1){ dw=box; dh=box/gr; } else { dh=box; dw=box*gr; }
        ctx.drawImage(gimg, cx-dw/2, boxTop+(box-dh)/2, dw, dh);
      }
      ctx.textAlign='center'; ctx.textBaseline='top'; ctx.fillStyle='#ffffff';
      var wsz=K.word.size; ctx.font='900 '+wsz+'px "Montserrat",Arial,sans-serif';
      var wmax=size*(K.word.fitPct/100), ww=ctx.measureText(wordTxt).width;
      if(ww>wmax&&ww>0){ wsz=Math.max(8,Math.floor(wsz*wmax/ww)); ctx.font='900 '+wsz+'px "Montserrat",Arial,sans-serif'; }
      // when a graphic is present the word sits at its base Y (no no-finger lift), matching the theme
      var wtop=((K.word.y-(hasGraphic?0:K.noFingerShift))/100)*size;
      ctx.fillText(wordTxt,size/2,wtop);
      ctx.fillStyle='rgba(255,255,255,0.72)'; ctx.font='900 '+K.tld.size+'px "Montserrat",Arial,sans-serif';
      ctx.fillText(tldTxt,size/2,(wtop+wsz)+((K.tld.gap||0)/100)*size);

      /* ---- www. pill: the only thing a stranger needs to read ---- */
      drawPill(ctx, size, 'www.'+domain);

      var url=null; try{ url=cv.toDataURL('image/png'); }catch(e){}
      cb(url);
    });
  }

  /* Hand-rolled rounded rect. ctx.roundRect() is Safari 16.4+/Chrome 99+ and this store's
     traffic includes old Android System WebView and in-app browsers, where it is absent —
     a missing method here would throw mid-render and silently kill the whole upload. */
  function roundRectPath(ctx,x,y,w,h,r){
    r=Math.min(r,h/2,w/2);
    ctx.beginPath();
    ctx.moveTo(x+r,y);
    ctx.lineTo(x+w-r,y);   ctx.arcTo(x+w,y,x+w,y+r,r);
    ctx.lineTo(x+w,y+h-r); ctx.arcTo(x+w,y+h,x+w-r,y+h,r);
    ctx.lineTo(x+r,y+h);   ctx.arcTo(x,y+h,x,y+h-r,r);
    ctx.lineTo(x,y+r);     ctx.arcTo(x,y,x+r,y,r);
    ctx.closePath();
  }

  function drawPill(ctx, size, text){
    var k=size/1200;                                   // knobs are authored at 1200px
    var fs=Math.round(PILL.fs*k), padX=PILL.padX*k, padY=PILL.padY*k;
    ctx.font='900 '+fs+'px "Montserrat",Arial,sans-serif';
    // fit-to-width: a long domain shrinks the type rather than running off the canvas
    var maxW=size*(PILL.maxWPct/100), tw=ctx.measureText(text).width;
    if(tw+padX*2>maxW && tw>0){
      fs=Math.max(10,Math.floor(fs*(maxW-padX*2)/tw));
      ctx.font='900 '+fs+'px "Montserrat",Arial,sans-serif';
      tw=ctx.measureText(text).width;
    }
    var w=tw+padX*2, h=fs+padY*2;
    var cy=(PILL.hem/100)*size, x=(size-w)/2, y=cy-h/2;

    ctx.save();                                        // shadow = "floating above the photo"
    ctx.shadowColor='rgba(0,0,0,0.45)';
    ctx.shadowBlur=size*0.012;
    ctx.shadowOffsetY=size*0.008;
    roundRectPath(ctx,x,y,w,h,h/2);
    ctx.fillStyle=PILL.bg; ctx.fill();
    ctx.restore();                                     // drop shadow before the keyline

    roundRectPath(ctx,x,y,w,h,h/2);                    // white keyline lifts it off black fabric
    ctx.lineWidth=Math.max(2,size*0.004);
    ctx.strokeStyle='rgba(255,255,255,0.96)';
    ctx.stroke();

    ctx.fillStyle=PILL.fg;
    ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.fillText(text, size/2, cy+1);
    ctx.textBaseline='top';   // restore the default this file renders text with
  }

  function doUpload(domain){
    render(domain, function(url){
      if(!url || url.indexOf('data:image/png')!==0) return;
      // NOTE: no keepalive — the render body is ~400KB and browsers cap keepalive bodies at 64KB
      // (that cap silently fails the request). Plain fetch; the upload runs on page-view, not unload.
      fetch(WORKER+'/render', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ domain:domain, image:url }) })
        .then(function(r){ return r.json().catch(function(){ return {}; }); })
        .then(function(j){ if(j && j.ok) markSeen(domain); })
        .catch(function(){});
    });
  }
  function maybeUpload(domain){
    if(!domain || !VALID.test(domain)) return;
    if(seen().indexOf(domain)>=0) return;        // this browser already pushed a v3 render
    /* v1 asked HEAD /shirt/<domain>.png first and bailed on a 200. That is exactly what
       would strand every already-rendered domain on its caption-less v1 image, so the
       HEAD check is deliberately NOT consulted here: the version-scoped seen-list above
       is what prevents repeat uploads. Restore the HEAD probe only after the whole fleet
       has been rewritten, and remember to bump RENDER_VER on the next artwork change. */
    doUpload(domain);
  }

  var _t=null;
  function tick(){ clearTimeout(_t); _t=setTimeout(function(){ maybeUpload(curDomain()); }, 1200); }
  function start(){
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function(){
      tick();
      var w=document.getElementById('shirt-domain-word');
      if(w){ try{ new MutationObserver(tick).observe(w,{ childList:true, characterData:true, subtree:true }); }catch(e){} }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();


/* =================================================================================
   PIECE 2 of this asset: the on-site "that's a real address" teach bar.
   Bundled here rather than in melol-capture-webview.js on purpose: that asset holds
   44 KB of hardened in-app-browser code and there is no reason to retransmit and risk
   any of it to append an unrelated UI module. Both pieces here are product-page only,
   this file is already loaded with defer from theme.liquid so no template edit is
   needed, and each piece is independently IIFE-guarded.
   ================================================================================= */

/* ME.LOL — "that's a real address" teach bar.
   ==================================================================================
   BUILD 2026-09-07b   ← read live via window.__melolAddr in the console on me.lol.

   THE PROBLEM IT SOLVES
   Civilians pattern-match "website" from .com and from "www." — not from .lol/.wtf.
   Proof from our own orders: someone paid $39.94 for queencatherine.darkwellcastle +
   queenmarie.darkwellcastle. That is not a TLD and never will be. A PAYING CUSTOMER
   read the format as text styling, not a URL. Typo arrivals have the same blind spot:
   they land on papa.lol, see PAPA.LOL on a shirt, and never connect the two.

   WHAT IT DOES
   Draws a fake browser address bar next to the shirt — ABOVE it on mobile, below the
   free-explainer on desktop — and types the domain into it the way the visitor just
   did — https://www.papa.lol — then collapses the "https://www." away, exactly like
   Chrome does, leaving papa.lol: the same lockup that's on the chest. That collapse IS
   the lesson. Address bar -> shirt, same string.

   Prefix is stripped HERE on purpose (the visitor is already on the site, so the bar
   supplies the context). On a SHARED image there is no context, so the www. stays —
   that's the pill in PIECE 1 of this same asset, and the matching drawPill() now
   pasted into renderSave() in theme.liquid (the Save Image download).

   WHERE IT LIVES
   Bottom of assets/melol-og.js, after the OG render uploader. Do NOT put it in
   theme.liquid: that template is 239,272 of Shopify's 262,144-byte hard limit — about
   22 KB of headroom — and melol-og.js is already loaded from there with defer, so
   riding along costs no template edit.

   PERFORMANCE CONTRACT (Android WebView is the constraint)
   The theme already runs ~29 whole-page MutationObservers and ~35 repeating timers,
   which is what chokes Android's System WebView. So this module adds:
     - ZERO whole-page MutationObservers
     - ZERO permanently-repeating timers (the placement poll self-cancels; the typing
       chain is a finite setTimeout sequence that ends)
     - two 'click' listeners, both scoped by a closest() guard: one to replay the
       animation, one to tag add-to-cart with the A/B arm
   Honours prefers-reduced-motion by rendering the final state with no animation.
   ================================================================================== */
window.__melolAddr = '2026-09-07b';

(function () {
  if (location.pathname.indexOf('/products/') !== 0) return;
  if (window.__melolAddrInit) return; window.__melolAddrInit = 1;

  var MB = 749;                 // mobile breakpoint, matches the rest of the theme
  var TYPE_MS = 55;             // per-character typing speed
  var HOLD_MS = 900;            // how long the full URL sits before the prefix collapses
  var PREFIX = 'https://www.';

  function curDomain() {
    try {
      var p = new URLSearchParams(location.search).get('domain');
      return (p || sessionStorage.getItem('melol_domain') || 'me.lol').toLowerCase().trim();
    } catch (e) { return 'me.lol'; }
  }
  function reduced() {
    try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch (e) { return false; }
  }

  /* ================================================================================
     A/B TEST — does teaching "this is a real domain" SUPPRESS add-to-cart?

     THE HYPOTHESIS (John's, 2026-09-06, and it inverts the premise this feature was
     built on): people who work out that the shirt carries somebody's actual domain may
     buy LESS, because the product stops reading as a joke you wear and starts reading
     as advertising you pay to wear.

     Our own order data leans that way. From what-people-actually-buy-2026-08-16.md,
     orders containing a PHRASE average $35.97 (n=5) vs $19.19 for the rest (n=52),
     p=0.016 — and those phrases (`yougotabreakwhentheyhiredyou.lol`, `peoplesuck.lol`)
     are sentences in domain costume that nobody would ever visit. The single highest
     order, $39.94, was `queencatherine.darkwellcastle` — a string that CANNOT be a
     domain. The further it sits from being an address, the more people spend.

     WHY THE BAR AND NOT THE PILL: the pill lives only in the og:image and the Save
     Image PNG — outside the purchase path entirely; a buyer never sees it before
     buying. This bar is the only piece of the "it's a real domain" lesson that sits
     IN the funnel, at the decision moment. So it is the only thing worth testing.

     MEASURE ADD-TO-CART, NOT ORDERS. Orders run ~0.7/day — hopeless for detecting
     anything. Add-to-cart runs ~500-700/week (growth-strategy.md), which splits two
     ways and still resolves a sizeable effect in a week or two.

     READ IT IN CLARITY, NOT GA4 — this store has no gtag (see abReport below).
     Filter by Custom Tag `ab_addressbar` = on / off for the denominator, and
     `ab_atc` = on / off for the numerator. Rate = ab_atc sessions / ab_addressbar
     sessions, per arm. Clarity samples at high traffic, but sampling is blind to the
     arm, so the RATIO stays valid — only the time-to-significance stretches.
     ================================================================================ */
  var AB_MODE = 'on';        // 'ab' = 50/50 test · 'on' = bar for everyone · 'off' = bar for nobody
  var AB_KEY  = 'melol_ab_addr_v1';   // bump the v to re-randomise the whole population

  function abVariant() {
    if (AB_MODE === 'on' || AB_MODE === 'off') return AB_MODE;
    if (window.__melolABAddr) return window.__melolABAddr;   // stable within the page
    var v = null;
    // localStorage first so the arm sticks across visits; sessionStorage is the fallback
    // for in-app browsers that block it. Without persistence a browsing visitor would be
    // re-flipped on every page view and the arms would blur into each other.
    try { v = localStorage.getItem(AB_KEY); } catch (e) {}
    if (v !== 'on' && v !== 'off') { try { v = sessionStorage.getItem(AB_KEY); } catch (e) {} }
    if (v !== 'on' && v !== 'off') {
      v = (Math.random() < 0.5) ? 'on' : 'off';
      try { localStorage.setItem(AB_KEY, v); } catch (e) {}
      try { sessionStorage.setItem(AB_KEY, v); } catch (e) {}
    }
    window.__melolABAddr = v;
    return v;
  }

  /* Exposure event — the DENOMINATOR.

     MEASURED 2026-09-07 in a real browser on this store: there is NO gtag. Not after
     9 seconds, no window.dataLayer, no googletagmanager/analytics.js script anywhere on
     the page. Google Analytics, if connected at all, runs inside Shopify's sandboxed Web
     Pixels, which deliberately do NOT expose a global gtag to theme code. So every
     `if (typeof gtag !== 'undefined') gtag(...)` call in this theme — domain_arrival,
     email_capture, and the first draft of this A/B — has always been dead code.

     CLARITY IS THE REAL CHANNEL. clarity is a live function on the page, already loaded
     and consent-gated in theme.liquid. clarity('set', k, v) writes a session Custom Tag
     you can filter the Clarity dashboard by, which is what makes the arms countable.
     gtag is still called if it ever exists — costs nothing, wins if GA is wired later.

     RETRY IS BOUNDED. The first draft rescheduled itself every 2.5s whenever gtag was
     missing — i.e. forever, on this store — an unbounded repeating timer, which is
     exactly what the performance contract above forbids and what chokes Android's
     System WebView. Four tries (~10s) then it stops for good. */
  var _abSent = false, _abTries = 0;
  function abReport(v) {
    if (_abSent) return;
    var ok = false;
    try { if (typeof clarity !== 'undefined') { clarity('set', 'ab_addressbar', v); ok = true; } } catch (e) {}
    try { if (typeof gtag !== 'undefined') { gtag('event', 'ab_addressbar', { variant: v, domain: curDomain() }); ok = true; } } catch (e) {}
    if (ok) { _abSent = true; return; }
    if (++_abTries < 4) setTimeout(function () { abReport(v); }, 2500);
  }

  /* ORDER-LEVEL ATTRIBUTION — added 2026-09-07b after John asked "which arm did those
     two orders come in on?" and the honest answer was: unknowable. The Clarity tag
     measures the RATE across sessions; it cannot tell you which arm an individual ORDER
     came from, because nothing carried the arm into the order record.

     A CART ATTRIBUTE fixes that: it survives checkout and lands on the order's
     customAttributes, queryable in one API call.

     Deliberately NOT a line-item property. Those ride the same form plumbing that
     produced the blank `Domain name on shirt` on order #1070 — the Infinite Options
     field sits OUTSIDE the <form> and reaches the cart only via the form="" association.
     A cart attribute is independent of the form, so it cannot disturb the one part of
     this store that has already shipped an unprintable order.

     Fired once per session, and delayed 1200ms so it lands AFTER /cart/add.js instead of
     racing it — Shopify serialises cart writes and a concurrent update can return a
     stale cart. Orders here take ~90s from landing, so 1.2s costs nothing. This is a
     plain fetch to a different endpoint, NOT another fetch patch: V600 already wraps
     window.fetch looking for '/cart/add', and '/cart/update.js' passes straight through. */
  var ATTR_KEY = 'melol_ab_attr_v1';
  function abTagCart(v) {
    try { if (sessionStorage.getItem(ATTR_KEY) === '1') return; } catch (e) {}
    setTimeout(function () {
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { ab_addressbar: v } })
        }).then(function (r) {
          if (r && r.ok) { try { sessionStorage.setItem(ATTR_KEY, '1'); } catch (e) {} }
        }).catch(function () {});
      } catch (e) {}
    }, 1200);
  }

  /* Add-to-cart, tagged by arm. CLICK DELEGATION ONLY — V600 already monkey-patches
     window.fetch AND XMLHttpRequest.prototype.open and is the leading suspect for the
     Jul 5 checkout-event break; a second patch is exactly what melol-capture-webview.js
     warns against. Matching mirrors that file's TRIGGER 4: name="add" or the literal
     "add to cart"/"add to bag" — never a bare /add/, which fires on the 'Add The
     "Finger"' variant label. Runs for BOTH arms, so it must sit outside the bar gate. */
  function abWireAddToCart(v) {
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('button,input[type=submit],a');
      if (!b) return;
      var nm = ((b.getAttribute && b.getAttribute('name')) || '').toLowerCase();
      var tx = ((b.textContent || '') + ' ' + ((b.getAttribute && b.getAttribute('aria-label')) || '')).toLowerCase();
      if (nm !== 'add' && !/add to cart|add to bag/.test(tx)) return;
      // NUMERATOR. Tag + event: the tag is what the Clarity dashboard filters on, the
      // event is the friendlier read in the Custom Events view. gtag stays as a no-op
      // that costs nothing and starts working the day GA is actually wired up.
      try { if (typeof clarity !== 'undefined') { clarity('set', 'ab_atc', v); clarity('event', 'ab_add_to_cart'); } } catch (e2) {}
      try { if (typeof gtag !== 'undefined') gtag('event', 'ab_add_to_cart', { variant: v, domain: curDomain() }); } catch (e2) {}
      abTagCart(v);   // -> order.customAttributes.ab_addressbar, so ORDERS become attributable
      // no dedupe on purpose: GA4 gives both event count and sessions-with-event, and
      // repeat clicks are symmetric across arms so they cannot bias the comparison.
    }, true);
  }

  /* Same anchor element the Featured strip and "Your shirts" already use — but ABOVE it
     on mobile, not below.

     WHY ABOVE (changed 2026-09-05b, from live testing): below the shirt image the bar sat
     under the fold on a phone. A typo arrival looks at the shirt and leaves; they never
     scroll, so the one thing that teaches them the domain is real was invisible to the
     exact audience it exists for. Above the media it is in the first viewport, and the
     metaphor is actually better there — address bars sit ON TOP of the page they loaded,
     so the layout reads as a browser window with the shirt as the page content.

     NOT overlaid on the photo, which was the other candidate: `.product-media` already
     carries the tap-to-cycle-finger handler, and #melolTapHint is positioned at 88% of
     the media height. An overlay would fight both. Above costs ~55px of scroll and
     collides with nothing. */
  function anchorFor(mobile) {
    if (mobile) {
      var mg = document.querySelector('media-gallery, .product-media-container, .product__media-wrapper, .product-media');
      if (mg && mg.getBoundingClientRect().width > 0) {
        return { host: mg.closest('media-gallery, .product-media-container, .product__media-wrapper') || mg, where: 'before' };
      }
    } else {
      var ex = document.getElementById('melol-free-explainer');
      if (ex) return { host: ex, where: 'after' };
      var h1 = document.querySelector('h1');
      var blk = h1 ? (h1.closest('.text-block') || h1.parentElement) : null;
      if (blk) return { host: blk, where: 'after' };
    }
    var h1b = document.querySelector('h1');
    var b2 = h1b ? (h1b.closest('.text-block') || h1b.parentElement) : null;
    return b2 ? { host: b2, where: 'after' } : null;
  }

  function injectCss() {
    if (document.getElementById('melolAddrCss')) return;
    var css =
      '#melolAddr{margin:14px 0 4px;font-family:Inter,Arial,sans-serif;width:100%;box-sizing:border-box;}' +
      '#melolAddr .ab-bar{display:flex;align-items:center;gap:9px;background:#fff;border:1.5px solid #dfe3e8;' +
        'border-radius:999px;padding:10px 16px;box-shadow:0 1px 4px rgba(0,0,0,.06);cursor:pointer;' +
        'overflow:hidden;min-width:0;}' +
      '#melolAddr .ab-lock{flex:0 0 auto;font-size:12px;line-height:1;opacity:.55;}' +
      '#melolAddr .ab-url{flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:clip;' +
        'font:600 16px/1.25 ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;color:#111;letter-spacing:.1px;}' +
      '#melolAddr .ab-pre{color:#9aa1a9;transition:opacity .32s ease,max-width .32s ease;' +
        'display:inline-block;max-width:12em;overflow:hidden;vertical-align:bottom;}' +
      '#melolAddr.is-collapsed .ab-pre{opacity:0;max-width:0;}' +
      '#melolAddr .ab-dom{color:#111;font-weight:700;}' +
      '#melolAddr .ab-caret{display:inline-block;width:1px;height:1.05em;background:#0a66ff;' +
        'vertical-align:-2px;margin-left:1px;animation:melolAbBlink 1s step-end infinite;}' +
      '#melolAddr.is-done .ab-caret{display:none;}' +
      '@keyframes melolAbBlink{0%,100%{opacity:1}50%{opacity:0}}' +
      '#melolAddr .ab-note{font-size:12.5px;line-height:1.45;color:#666;margin:7px 2px 0;opacity:0;' +
        'transition:opacity .3s ease;}' +
      '#melolAddr.is-done .ab-note{opacity:1;}' +
      '#melolAddr .ab-note b{color:#111;font-weight:700;}' +
      /* mobile sits ABOVE the shirt, so every pixel it takes pushes the hero down.
         Slimmer bar, smaller type, single-line note — ~55px total instead of ~90px. */
      '#melolAddr.is-mobile{margin:6px 0 8px;}' +
      '#melolAddr.is-mobile .ab-bar{padding:8px 13px;gap:7px;}' +
      '#melolAddr.is-mobile .ab-url{font-size:14.5px;}' +
      '#melolAddr.is-mobile .ab-note{font-size:12px;margin:5px 2px 0;}' +
      '@media (prefers-reduced-motion: reduce){' +
        '#melolAddr .ab-caret{animation:none;}' +
        '#melolAddr .ab-pre,#melolAddr .ab-note{transition:none;}}';
    try {
      var st = document.createElement('style');
      st.id = 'melolAddrCss'; st.type = 'text/css';
      st.appendChild(document.createTextNode(css));
      (document.head || document.documentElement).appendChild(st);
    } catch (e) {}
  }

  var _timers = [];
  function clearTimers() { for (var i = 0; i < _timers.length; i++) clearTimeout(_timers[i]); _timers = []; }
  function later(fn, ms) { var t = setTimeout(fn, ms); _timers.push(t); return t; }

  function run(box, domain) {
    var pre = box.querySelector('.ab-pre');
    var dom = box.querySelector('.ab-dom');
    var full = PREFIX + domain;

    clearTimers();
    box.classList.remove('is-collapsed', 'is-done');
    pre.textContent = ''; dom.textContent = '';

    if (reduced()) {                       // no animation: land on the finished state
      pre.textContent = PREFIX; dom.textContent = domain;
      box.classList.add('is-collapsed', 'is-done');
      return;
    }

    var i = 0;
    (function step() {
      if (i <= full.length) {
        var s = full.slice(0, i);
        if (s.length <= PREFIX.length) { pre.textContent = s; dom.textContent = ''; }
        else { pre.textContent = PREFIX; dom.textContent = s.slice(PREFIX.length); }
        i++;
        later(step, TYPE_MS);
        return;
      }
      // full URL is typed — hold it, then collapse the prefix the way a browser does
      later(function () {
        box.classList.add('is-collapsed');
        later(function () { box.classList.add('is-done'); }, 340);
      }, HOLD_MS);
    })();
  }

  function build() {
    var mobile = window.innerWidth <= MB;
    var mode = mobile ? 'm' : 'd';
    var domain = curDomain();

    var ex = document.getElementById('melolAddr');
    if (ex) {
      // already placed for this domain + layout — leave it alone
      if (ex.getAttribute('data-dom') === domain && ex.getAttribute('data-mode') === mode) return true;
      ex.remove();
    }

    var a = anchorFor(mobile);
    if (!a || !a.host || !a.host.parentNode) return false;

    injectCss();
    var box = document.createElement('div');
    box.id = 'melolAddr';
    box.className = mobile ? 'is-mobile' : 'is-desktop';
    box.setAttribute('data-dom', domain);
    box.setAttribute('data-mode', mode);
    // one tight line on mobile (it sits above the hero); the fuller line on desktop
    var note = mobile
      ? '☝️ <b>' + domain + '</b> is a real address. You just typed it.'
      : 'You didn’t land here by magic — <b>' + domain +
        '</b> is a real web address, and you just typed it. Now it’s a shirt.';
    box.innerHTML =
      '<div class="ab-bar" role="img" aria-label="Web address ' + domain + '">' +
        '<span class="ab-lock">🔒</span>' +
        '<span class="ab-url"><span class="ab-pre"></span><span class="ab-dom"></span><span class="ab-caret"></span></span>' +
      '</div>' +
      '<p class="ab-note">' + note + '</p>';

    if (a.where === 'after') a.host.parentNode.insertBefore(box, a.host.nextSibling);
    else a.host.parentNode.insertBefore(box, a.host);

    // tap to replay — the only persistent listener this module adds
    box.addEventListener('click', function () { run(box, domain); });

    run(box, domain);
    return true;
  }

  /* Placement poll that SELF-CANCELS. No MutationObserver: Horizon renders the media
     gallery within the first second or two, and once we're placed we never re-scan. */
  function boot() {
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (build() || n > 24) clearInterval(iv);   // ~7.2s ceiling, then give up for good
    }, 300);
    build();
  }

  // Re-place only on a real layout flip (mobile <-> desktop), debounced. Not on every resize.
  var _rt = null, _wasMobile = window.innerWidth <= MB;
  window.addEventListener('resize', function () {
    var nowMobile = window.innerWidth <= MB;
    if (nowMobile === _wasMobile) return;
    _wasMobile = nowMobile;
    clearTimeout(_rt);
    _rt = setTimeout(build, 180);
  });

  /* Decide the arm BEFORE anything renders, so the control group never sees a flash of
     the bar. Instrumentation runs for both arms; only the render is gated. */
  /* 2026-10-20 PIN-TO-TOP: blocks inserted above the fold after first paint make Chrome scroll-anchor a fresh mobile load down to scrollY~171, leaving this bar 52px ABOVE the viewport on a page nobody scrolled. Pin to 0 until the visitor touches the page (2.5s max); skipped on hash links and back/forward restores. One line because it was typed into the editor replace box. */ var _um=false;['touchstart','touchmove','wheel','keydown','pointerdown'].forEach(function(e){window.addEventListener(e,function(){_um=true;},{passive:true,once:true});});var _navT=((performance.getEntriesByType&&performance.getEntriesByType('navigation')[0])||{}).type||'';function _pinTop(){if(_um||location.hash||_navT==='back_forward')return;if(window.scrollY>0&&window.scrollY<600)window.scrollTo(0,0);}if(window.innerWidth<=MB){var _pin0=Date.now();(function _pinAgain(){_pinTop();if(!_um&&Date.now()-_pin0<2500)setTimeout(_pinAgain,120);})();} var _v = abVariant();
  abReport(_v);
  abWireAddToCart(_v);

  if (_v === 'off') return;    // control: no bar at all — exactly the pre-feature page

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
